const config = {
    apiKey: "AIzaSyAdEHnwyImVNHQxQWJ57rsyYnTQhwuMAmQ",
    authDomain: "crud-app-92a33.firebaseapp.com",
    projectId: "crud-app-92a33",
    storageBucket: "crud-app-92a33.appspot.com",
    messagingSenderId: "299287965542",
    appId: "1:299287965542:web:f773503e58558c17b122a7"
}
export {
  config
}
